import * as components from './components'

export default [
  {
    path: '/career/:code/home',
    component: components.CareerIntro,
    name: 'careerDetail',
    props: true
  },
  {
    path: '/career/:code/careerProspects',
    component: components.CareerDetail,
    name: 'careerDetailProspects',
    props: true
  },
  {
    path: '/career/:code/related',
    component: components.RelatedCareers,
    name: 'relatedCareers',
    props: true
  },
  {
    path: '/career/:code/edit',
    component: components.EditCareer,
    name: 'editCareer',
    props: true
  },
  {
    path: '/career/list',
    component: components.CareerList,
    name: 'careerList',
    props: true
  },
  {
    path: '/career/:code/programs',
    component: components.CareerPrograms,
    name: 'careerPrograms',
    props: true
  },
  {
    path: '/career/:code/streams',
    component: components.CareerStreams,
    name: 'careerStreams',
    props: true
  },
  {
    path: '/career/:code/insights',
    component: components.CareerInsights,
    name: 'careerInsights',
    props: true
  },
  {
    path: '/career/:code/cocurricular',
    component: components.CareerCocurricular,
    name: 'careerCocurricular',
    props: true
  },
  {
    path: '/career/:code/jobs',
    component: components.CareerJobs,
    name: 'careerJobs',
    props: true
  },
  {
    path: '/career/institution/upload',
    component: components.InstitutionCareerUpload,
    name: 'institutionCareerUpload',
    props: true
  }
]



// WEBPACK FOOTER //
// ./src/app/career/routes.js